import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styles from './navigation.module.scss';
import { ReactComponent as MapIcon } from '../../../assets/icon_map.svg';
import { ReactComponent as ObjectIcon } from '../../../assets/icon_object.svg';
import { ReactComponent as EventIcon } from '../../../assets/icon_events.svg';
import { ReactComponent as TimetableIcon } from '../../../assets/icon_timetable.svg';
import { ReactComponent as WeatherIcon } from '../../../assets/icon_weather.svg';
import { ReactComponent as TrialIcon } from '../../../assets/icon_trial.svg';

const Navigation = ({ languagePl, embedded, closedCardOnClickNavigation }) => {
  const { t } = useTranslation();

  return (
    <nav className={styles.navigation}>
      <ul className={!embedded ? styles.navigation__list : styles.navigation__listEmbedded}>
        <li className={styles.navigation__item}>
          <NavLink
            className={styles.navigation__link}
            activeClassName={styles.navigation__linkActive}
            onClick={closedCardOnClickNavigation}
            exact
            to="/"
          >
            <MapIcon className={styles.navigation__icon} />
            {t('navigation.first')}
            <div className={styles.navigation__underline} />
          </NavLink>
        </li>
        <li className={styles.navigation__item}>
          <NavLink
            className={styles.navigation__link}
            activeClassName={styles.navigation__linkActive}
            to="/object"
          >
            <ObjectIcon className={styles.navigation__icon} />
            {t('navigation.second')}
            <div className={styles.navigation__underline} />
          </NavLink>
        </li>
        {!embedded && (
          <li className={styles.navigation__item}>
            {languagePl ? (
              <NavLink
                className={styles.navigation__link}
                activeClassName={styles.navigation__linkActive}
                to="/events"
              >
                <EventIcon className={styles.navigation__icon} />
                {t('navigation.third')}
                <div className={styles.navigation__underline} />
              </NavLink>
            ) : (
              <div className={styles.navigation__linkDisabled}>
                <EventIcon className={styles.navigation__icon} />
                {t('navigation.third')}
                <div className={styles.navigation__underline} />
              </div>
            )}
          </li>
        )}
        <li className={styles.navigation__item}>
          <NavLink
            className={styles.navigation__link}
            activeClassName={styles.navigation__linkActive}
            to="/timetable"
          >
            <TimetableIcon className={styles.navigation__icon} />
            {t('navigation.fourth')}
            <div className={styles.navigation__underline} />
          </NavLink>
        </li>
        {!embedded && (
          <li className={styles.navigation__item}>
            <NavLink
              className={styles.navigation__link}
              activeClassName={styles.navigation__linkActive}
              to="/weather"
            >
              <WeatherIcon className={styles.navigation__icon} />
              {t('navigation.fifth')}
              <div className={styles.navigation__underline} />
            </NavLink>
          </li>
        )}
        <li className={styles.navigation__item}>
          <NavLink
            className={styles.navigation__link}
            activeClassName={styles.navigation__linkActive}
            to="/trail"
          >
            <TrialIcon className={styles.navigation__icon} />
            {t('navigation.sixth')}
            <div className={styles.navigation__underline} />
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
